/* eslint-disable */
import ShowTimeOutWarning from "@/components/probaworkflows_base_components/ShowTimeOutWarning/ShowTimeOutWarning.vue";
import store from '@/store/store';
import { CLIENT_BRANDING, no_timeout, timer_warning } from "@/utils/constants/constants";
import { setup_axios_interceptors } from '@/utils/interceptors/axios_interceptors.js';
import { setup_logout_interceptors } from '@/utils/interceptors/force_logout_interceptor.js';
import { statusMixin } from '@/utils/mixins/status_mixin';
import axios from 'axios';
import dotenv from 'dotenv';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Set axios defaults
axios.defaults.withCredentials = true;

dotenv.config();



const domain = window.CLIENT_DOMAIN;
const isValidDomain = domain && domain !== 'localhost';

dotenv.config();

// Initialize axios interceptors
setup_axios_interceptors();
setup_logout_interceptors();

const app = createApp(App, { isValidDomain });
app.use(router);
app.use(store);
// Register globally
app.mixin(statusMixin);

// --------------------
// Dynamic Branding Logic For TrustFirst
// --------------------

// fetch logos from frontend
const logos = {
  'monitoring.dwypd.gov': require('@/assets/images/dwypd/logos/women_logo.png'),
  'dwypd.complyon': require('@/assets/images/dwypd/logos/women_logo.png'),
  'monitoring.dwypd.gov': require('@/assets/images/dwypd/logos/women_logo.png'),
  'monitoring.complyon': require('@/assets/images/dwypd/logos/women_logo.png'),
};

const images = {
   'monitoring.dwypd.gov': require('@/assets/images/dwypd/pictures/dwypd_login.png'),
   'dwypd.complyon': require('@/assets/images/dwypd/pictures/dwypd_login.png'),
   'monitoring.complyon': require('@/assets/images/dwypd/pictures/dwypd_login.png'),
};

const form_backgrounds = {
  'monitoring.dwypd.gov': require('@/assets/images/dwypd/pictures/dwypd_bg.png'),
  'dwypd.complyon': require('@/assets/images/dwypd/pictures/dwypd_bg.png'),
  'monitoring.complyon': require('@/assets/images/dwypd/pictures/dwypd_bg.png'),
};

const favicons = {
  'bolide.complyon': require('@/assets/images/bollide/logos/bolide_favicon.png'),
  'x-verdict': require('@/assets/images/x-verdict/logos/x_verdict_favicon_logo.png'),
};


// Apply branding colors dynamically to CSS variables
const apply_branding_colors = (colors) => {
  const root = document.documentElement;
  const colorMap = {
    primary: '--primary-color',
    secondary: '--secondary-color',
    tertiary_colour: '--tertiary-color',
    accent: '--accent-color',
    highlight: '--highlight-color',
    new: '--new-color',
    text: '--text-color',
    gradient: '--gradient'
  };

  Object.entries(colorMap).forEach(([key, cssVar]) => {
    const value = Reflect.get(colors, key);
    if (value) {
      root.style.setProperty(cssVar, value);
    }
  });
};

const get_clean_domain = () => {
  const hostname = window.location.host.split(':')[0];
  const parts = hostname.split('.');
  parts.pop(); // Remove TLD

  const first = parts[0]?.toLowerCase();
  if (['uat', 'stage', 'staging', 'demo'].includes(first)) {
    parts.shift();
  }

  return parts.join('.');
};

// Set client branding globally on the Vue app instance
const set_client_branding = (branding_data) => {
  if (branding_data?.colors) {
    apply_branding_colors(branding_data.colors);
  }

  const domain_key = get_clean_domain();
  const selected_logo = Reflect.get(logos, domain_key);
  const selected_image = Reflect.get(images, domain_key);
  const selected_bg = Reflect.get(form_backgrounds, domain_key);

  // Set logo globally
  app.config.globalProperties.$clientLogo = selected_logo;

  // Set favicon dynamically (prefer favicon, fallback to logo)
  const favicon = document.querySelector('link[rel="icon"]');
  const selected_favicon = Reflect.get(favicons, domain_key);
  const selected_icon = selected_favicon || selected_logo; // prefer favicon, fallback to logo

  if (favicon && selected_icon) {
    favicon.href = selected_icon;
  }


  // Optional: add other assets
  app.config.globalProperties.$clientImage = {
    onboarding: selected_image,
    background: selected_bg
  };

    // Apply background directly to body or root container
  if (selected_image) {
    document.body.style.setProperty(
      '--app-bg-image',
      `url("${selected_image}")`
    );
  }
};

// Fetch branding from backend API and apply it
const fetch_branding = () => {
  const domain = get_clean_domain();

  return axios.get(CLIENT_BRANDING, {
    params: { domain }
  })
    .then(response => {
      set_client_branding(response.data || {});
    })
    .catch(error => {
      console.warn("Failed to fetch client branding:", error);
  });
};

// --------------------
// Mount app after fetching branding
// --------------------
fetch_branding().finally(() => {
  app.mount('#app');
});

// --------------------
// Timeout & Inactivity Logic (unchanged)
// --------------------
let inactivity_timer;
let countdown_timer;
let warning_modal_instance;
const inactivity_timeout = no_timeout;
const timeout_warning = timer_warning;

function should_enable_timeout() {
  const current_route = router.currentRoute.value;
  return current_route.name !== 'OneTimePin';
}

function start_inactivity_timer() {
  if (!should_enable_timeout()) return;

  if (inactivity_timer) clearTimeout(inactivity_timer);
  if (countdown_timer) clearInterval(countdown_timer);

  if (warning_modal_instance) {
    warning_modal_instance.unmount();
    warning_modal_instance = null;
  }

  inactivity_timer = setTimeout(() => {
    show_timeout_warning();
  }, inactivity_timeout - timeout_warning);
}

function show_timeout_warning() {
  if (!should_enable_timeout()) return;

  const modal_container = document.createElement('div');
  document.body.appendChild(modal_container);

  warning_modal_instance = createApp(ShowTimeOutWarning, {
    seconds_left: 30,
    on_continue: () => {
      clearInterval(countdown_timer);
      warning_modal_instance.unmount();
      document.body.removeChild(modal_container);
      reset_inactivity_timer();
    },
    on_logout: () => {
      clearInterval(countdown_timer);
      end_session();
    }
  });

  warning_modal_instance.mount(modal_container);

  countdown_timer = setInterval(() => {
    const seconds_left = warning_modal_instance._instance.props.seconds_left - 1;
    warning_modal_instance._instance.props.seconds_left = seconds_left;

    if (seconds_left <= 0) {
      clearInterval(countdown_timer);
      end_session();
    }
  }, 1000);
}

function reset_inactivity_timer() {
  if (sessionStorage.getItem('token') && should_enable_timeout()) {
    start_inactivity_timer();
  }
}

function end_session() {
  clearTimeout(inactivity_timer);
  clearInterval(countdown_timer);

  if (warning_modal_instance) {
    warning_modal_instance.unmount();
    warning_modal_instance = null;
  }

  sessionStorage.removeItem('token');
  sessionStorage.removeItem('otp_verified');
  sessionStorage.setItem('auth_redirect_reason', 'Session expired due to inactivity.');
  router.push({ name: 'UserLogin' });
}

const activity_events = ['mousedown', 'keypress', 'scroll', 'touchstart', 'click'];
activity_events.forEach(event => {
  document.addEventListener(event, reset_inactivity_timer);
});

if (sessionStorage.getItem('token') && should_enable_timeout()) {
  start_inactivity_timer();
}

router.afterEach((to) => {
  if (to.name !== 'OneTimePin') {
    reset_inactivity_timer();
  }
});
